import { useReducedMotion } from "framer-motion";

const FEATURES = [
  "Money flow",
  "Budgets & goals",
  "Net worth",
  "Multi-currency",
  "Recurring",
  "Wellness",
  "AI coach",
  "Voice entry",
  "Statement import",
];

function Chip({ label }: { label: string }) {
  return (
    <span className="inline-flex shrink-0 items-center gap-2 rounded-full border border-border bg-background px-4 py-2 text-sm font-semibold text-muted-foreground">
      <span className="h-1.5 w-1.5 rounded-full bg-primary" />
      {label}
    </span>
  );
}

/** A quiet capability strip. Auto-scrolls unless reduced-motion is on. */
export function FeatureMarquee() {
  const reduce = useReducedMotion();
  const items = reduce ? FEATURES : [...FEATURES, ...FEATURES];
  return (
    <div className="border-y border-border bg-card py-5">
      <div className="relative overflow-hidden">
        <div
          className={`flex w-max gap-3 px-6 ${reduce ? "flex-wrap justify-center" : "animate-marquee"}`}
        >
          {items.map((f, i) => (
            <Chip key={`${f}-${i}`} label={f} />
          ))}
        </div>
      </div>
    </div>
  );
}
